
import { defineComponent } from 'vue'
import Checkbox from 'primevue/checkbox'
import SchedulerSnapshotAccordion from './accordions/SchedulerSnapshotAccordion.vue'
import SchedulerFileAccordion from './accordions/SchedulerFileAccordion.vue'
import SchedulerDocumentAccordion from './accordions/SchedulerDocumentAccordion.vue'
import SchedulerJavaClassAccordion from './accordions/SchedulerJavaClassAccordion.vue'
import SchedulerMailAccordion from './accordions/SchedulerMailAccordion.vue'

export default defineComponent({
    name: 'scheduler-tming-output-document-detail',
    components: { Checkbox, SchedulerSnapshotAccordion, SchedulerFileAccordion, SchedulerJavaClassAccordion, SchedulerDocumentAccordion, SchedulerMailAccordion },
    props: { propDocument: { type: Object }, functionalities: { type: Array }, datasets: { type: Array }, jobInfo: { type: Object }, documentWithUniqueMail: { type: Object } },
    emits: ['sendUniqueMailSelected', 'uniqueMailOptionsChanged'],
    data() {
        return {
            document: null as any
        }
    },
    watch: {
        propDocument() {
            this.loadDocument()
        }
    },
    created() {
        this.loadDocument()
    },
    methods: {
        loadDocument() {
            this.document = this.propDocument
            if (this.document.uniqueMail) this.setSetUniqueMailSelected(this.document)
            this.document.invalid = {}
        },
        removeProperty(propName: string) {
            if (!this.document[propName]) {
                delete this.document[propName]
            }

            if (this.document.invalid) {
                this.resetInvalid(propName)
            }
        },
        resetInvalid(propName: string) {
            switch (propName) {
                case 'saveassnapshot':
                    this.document.invalid.invalidSnapshot = false
                    break
                case 'saveasfile':
                    this.document.invalid.invalidFile = false
                    break
                case 'saveasdocument':
                    this.document.invalid.invalidDocument = false
                    break
                case 'sendtojavaclass':
                    this.document.invalid.invalidJavaClass = false
                    break
                case 'sendmail':
                    this.document.invalid.invalidMail = false
            }
        },
        setSetUniqueMailSelected(document: any) {
            this.$emit('sendUniqueMailSelected', document)
        }
    }
})
